module.exports = __webpack_public_path__ + "static/media/man-laughing.6425aae5.png";